import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  root: {
    padding: theme.spacing(0.7, 2),
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2.45),
    },
  },
  youAreHere: {
    marginRight: theme.spacing(0.8),
    color: theme.palette.grey[500],
  },
  divider: {
    marginBottom: theme.spacing(2),
  },
  icon: {
    width: '20px',
  },
}));

export default useStyles;
